import { createReducer } from 'redux-act';
import * as actions from 'modules/actions';

export type IJoinedCode = {
	[x: number]: {
		joined: boolean;
		num_teams: number;
	};
};

export interface IPostLeagueJoin {
	league_id: number;
	code: string;
}

export interface JoinLeagueReducerState {
	joined_codes: IJoinedCode;
	joined_id: number;
}

const initialState: JoinLeagueReducerState = {
	joined_codes: {},
	joined_id: 0
};

export const join_league = createReducer({}, initialState)
	.on(actions.postLeagueJoinSuccess, (state, payload) => ({
		...state,
		joined_codes: {
			...state.joined_codes,
			...payload
		}
	}))
	.on(actions.postLeagueLeaveSuccess, (state, payload) => ({
		...state,
		joined_codes: {
			...state.joined_codes,
			...payload
		}
	}))
	.on(actions.searchAndJoinSuccess, (state, payload) => ({
		...state,
		joined_id: payload,

	}))
	.on(actions.postLeagueJoinFailed, (state) => ({
		...state
	}));
